import "intl-tel-input/build/css/intlTelInput.css";
import '_tradeholding/scss/form/form.phoneinput.scss';
import PluginBase from '_loaders/PluginBase';

import intlTelInput from "intl-tel-input";

class TH_IntlTelInput extends PluginBase {
    constructor(main) {
        super(main);
    }

    
    __init() {
        this.plugin = intlTelInput(this.dom.main[0], this.options);
        this.dom.main.data('intltelinput', this.plugin);

        if (typeof this.dom.hidden.val() != 'undefined') this.plugin.setNumber(this.dom.hidden.val());

        
        this.dom.countryList = this.dom.wrap.find('ul.iti__country-list');
        this.dom.countryList.css('width', this.dom.wrap.width());

        super.__init();
    }


    /** Build the default events of this plugin - if you want to specify default events, override this function in your extended class
     * 
     */
    __buildDefaultEvents() {
        let selfRef = this;

        super.__buildDefaultEvents();

		this.dom.main.on('change', function(event) {
			selfRef.dom.hidden.val(selfRef.plugin.getNumber());
		});


    }

    /** Build the default dom structure of this plugin
     *
     */
    __buildDom() {
        let domExtend = {
            wrap: null,
            hidden: null
        }

        domExtend.wrap = this.dom.main.parents('.phone-input-wrapper');
        domExtend.hidden = domExtend.wrap.find('input[name=' + this.options['linked-to'] + ']');
        domExtend.countryList = null;

        this.dom = jQuery.extend(true, domExtend, this.dom);

        super.__buildDom();
    }

    /** Build the default options of this plugin 
     * 
     */
    __buildDefaultOptions() {
        this.options = jQuery.extend(true, {
            initialCountry: "auto", 
            autoPlaceholder: false, 
            preferredCountries: ['ro'],
            geoIpLookup: function(callback) {
				jQuery.get('https://ipinfo.io', function() {}, "jsonp").always(function(resp) {
				  let countryCode = (resp && resp.country) ? resp.country : "";
                  
                    callback(countryCode);
				});
			},
			utilsScript: "https://cdn.mondhome.com/plugins/intlTelInput/v16.0.0/js/utils.js"
        }, this.options);

        super.__buildDefaultOptions();
    }

    
    static initMultiple() {
        let definition = this;

        jQuery(".phone-input-container:not(.th-inited)").each(function() {
            if (jQuery(this).hasClass('th-no-init')) return;

            new definition(jQuery(this));
        });
    }
}

export default TH_IntlTelInput;